import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

// A new hoops page starts at its top. P6-329c (GN-2c).
//
// ═══════════════════════════════════════════════════════════════════════════
// THE PLAYERS LIST IS ABOUT 31,000 PIXELS TALL ON A PHONE, AND A ROUTE CHANGE DOES NOT MOVE THE WINDOW
// ═══════════════════════════════════════════════════════════════════════════
//
// react-router swaps a route's element and leaves the document where it was: a member who scrolls the 582 players to
// "Q" and taps one lands on that player's page at the same scroll offset, which is the bottom of it, or past it. The
// site has no scroll handling anywhere (`ScrollRestoration` needs a data router, and this app is a plain `<BrowserRouter>`),
// so the season views do the one thing that matters themselves: a PUSH to a different path scrolls to the top.
//
// ONLY A PUSH, AND ONLY WHEN THE PATH CHANGES. Back (a POP) is the browser's to restore, and a season or a category
// chosen with `replace` is a refinement of the page you are on, so neither jumps. The effect keys on the pathname, so a
// query-only change cannot trigger it.

export function useScrollToTopOnPush() {
  const { pathname } = useLocation()
  const type = useNavigationType()
  useEffect(() => {
    if (type === 'PUSH' && typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0)
    }
    // Only the path decides: the navigation type belongs to the change that brought the path here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}
